import { Picture } from "./@types";

export const parsePicture = (response: any): Picture => {
    const pic: Picture = {
        ...response,
        thumbnail: response.thumbnailUrl,
        imagePath: response.filePath,
    };
    return pic;
}